/**
 * Return true to stop traversal
 */
type StopConditionFn = (el: HTMLElement) => boolean;

const traverseDom = (el: HTMLElement | null, stopConditionFn: StopConditionFn): void => {
  if (el == null) return;
  if (el === document.body) return;

  const shouldStop = stopConditionFn(el);
  if (shouldStop) return;

  traverseDom(el.parentElement, stopConditionFn);
};

export enum AccumulateUiSectionFormat {
  String,
  Array
}
export interface AccumulateSectionUiConfig {
  /**
   * @default false
   */
  shouldTrackSelf?: boolean;
  /**
   * @default AccumulateUiSectionFormat.String
   */
  format?: AccumulateUiSectionFormat;
};

export const finalizeSectionUi = (sectionFragments: string[]): string | null => {
  const joined = sectionFragments.join('/');

  if (!joined) return null;

  return `ui/${joined}`;
};

export function accumulateSectionUi(el: HTMLElement): string | null;
export function accumulateSectionUi(el: HTMLElement, options: { shouldTrackSelf?: boolean; format?: AccumulateUiSectionFormat.String }): string | null;
export function accumulateSectionUi(el: HTMLElement, options: { shouldTrackSelf?: boolean; format: AccumulateUiSectionFormat.Array }): string[];
export function accumulateSectionUi(el: HTMLElement, options: AccumulateSectionUiConfig = {}): string | string[] | null {
  let acc: string[] = [];
  const root = options.shouldTrackSelf ? el : el.parentElement;

  traverseDom(root, (el): boolean => {
    if (el.dataset.uiSection) {
      acc.push(el.dataset.uiSection);
    }

    return false;
  });

  acc = acc.reverse();

  if (options.format === AccumulateUiSectionFormat.Array) {
    return acc;
  }

  return finalizeSectionUi(acc);
};
